import React from 'react';
import { Mail } from 'lucide-react';

type FooterFRProps = {
  showRoiLink?: boolean;
  variant?: 'agents' | 'partenaires';
};

const FooterFR: React.FC<FooterFRProps> = ({ showRoiLink = false, variant = 'partenaires' }) => {
  const tagline = 'Conversion de visites virtuelles Matterport en vidéos';

  return (
    <footer className="bg-white text-gray-800 border-t border-[#E2E8F0]">
      <div className="container mx-auto max-w-7xl py-6 px-4 lg:py-[48px] lg:px-[64px]">
        {/* Desktop : ligne 1 (logo+tagline à gauche, liens à droite) puis email + copyright sous le bloc gauche */}
        <div className="hidden lg:block font-manrope">
          <div className="flex justify-between items-center">
            <div className="flex flex-col items-start">
              <img src="/logo3D.png" alt="3DtoVideo Logo" className="h-12 w-auto object-contain block m-0 p-0" style={{ marginLeft: 0, paddingLeft: 0 }} />
              <p className="text-gray-600 leading-relaxed max-w-sm text-sm m-0 mt-1">{tagline}</p>
            </div>
            <div className="flex items-center justify-end gap-x-2 text-sm text-gray-500">
              <a href="#pricing" className="hover:text-[#3C59B2] transition-colors">Tarifs</a>
              <span className="text-gray-400" aria-hidden>·</span>
              {showRoiLink && (
                <>
                  <a href="#roi-calculator" className="hover:text-[#3C59B2] transition-colors">Calculateur ROI</a>
                  <span className="text-gray-400" aria-hidden>·</span>
                </>
              )}
              <a href="#faq" className="hover:text-[#3C59B2] transition-colors">FAQ</a>
              <span className="text-gray-400" aria-hidden>·</span>
              <a href="https://www.youtube.com/@3dtovideo" target="_blank" rel="noopener noreferrer" className="hover:text-[#3C59B2] transition-colors p-0.5 rounded hover:bg-gray-100 flex items-center justify-center" aria-label="YouTube">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>
          <div className="flex flex-col items-start mt-8">
            <a href="mailto:contact@3dtovideo.com" className="text-gray-500 hover:text-[#3C59B2] transition-colors text-sm inline-flex items-center gap-1.5">
              <Mail className="w-4 h-4 shrink-0" />
              contact@3dtovideo.com
            </a>
            <div className="text-gray-500 text-sm mt-4">© 2026 3dtovideo.com</div>
          </div>
        </div>

        {/* Mobile : logo+tagline groupés, puis contact, © 2026, puis liens */}
        <div className="lg:hidden font-manrope flex flex-col items-start pl-0 ml-0 w-full">
          <div className="flex flex-col items-start">
            <img src="/logo3D.png" alt="3DtoVideo Logo" className="h-12 w-auto object-contain block m-0 p-0" style={{ marginLeft: 0, paddingLeft: 0 }} />
            <p className="text-gray-600 leading-relaxed max-w-sm text-sm m-0 mt-1">
              {tagline}
            </p>
          </div>
          <a href="mailto:contact@3dtovideo.com" className="text-gray-500 hover:text-[#3C59B2] transition-colors text-sm inline-flex items-center gap-1.5 mt-8">
            <Mail className="w-4 h-4 shrink-0" />
            contact@3dtovideo.com
          </a>
          <div className="flex flex-wrap items-center justify-start gap-x-2 gap-y-0 text-sm text-gray-500 shrink-0 mt-6">
            <a href="#pricing" className="hover:text-[#3C59B2] transition-colors">Tarifs</a>
            <span className="text-gray-400" aria-hidden>·</span>
            {showRoiLink && (
              <>
                <a href="#roi-calculator" className="hover:text-[#3C59B2] transition-colors">Calculateur ROI</a>
                <span className="text-gray-400" aria-hidden>·</span>
              </>
            )}
            <a href="#faq" className="hover:text-[#3C59B2] transition-colors">FAQ</a>
            <span className="text-gray-400" aria-hidden>·</span>
            <a href="https://www.youtube.com/@3dtovideo" target="_blank" rel="noopener noreferrer" className="hover:text-[#3C59B2] transition-colors p-0.5 rounded hover:bg-gray-100 flex items-center justify-center" aria-label="YouTube">
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
          <div className="text-gray-500 text-sm mt-4">© 2026 3dtovideo.com</div>
        </div>
      </div>
    </footer>
  );
};

export default FooterFR;
